<template>
  <div class="wrapper">
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item label="商品名称">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.goodsName"
            clearable
          />
        </el-form-item>
        <el-form-item label="客服编号">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.customerNumber"
            clearable
          />
        </el-form-item>
        <el-form-item label="是否推荐">
          <!-- <el-checkbox
            @change="changeCheckBox"
          ></el-checkbox> -->
          <el-select
            v-model="searchData.isRecommend"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-form-item>
            <el-button
              size="mini"
              style="width: 90px; margin-left: 50px"
              type="primary"
              @click="addGoods"
              >添加</el-button
            >
            <el-button
              size="mini"
              style="width: 90px"
              type="primary"
              @click="getList"
              >查询</el-button
            >
            <el-button size="mini" type="primary" @click="clearList"
              >清空查询条件</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto; overflow-y: scroll;height: 606px"
        tooltip-effect="light"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="goodsName"
          label="商品名称"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="customerNumber"
          label="客服编号"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="salesCount"
          label="销售数量"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="price"
          label="实际售价"
          align="center"
          width="120"
        ></el-table-column>

        <el-table-column
          prop="oldPrice"
          label="原价"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="coverUrl"
          label="封面图"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <viewer>
              <img
                :src="row.coverUrl"
                alt=""
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsDesc"
          label="商品描述"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="isRecommend"
          label="是否推荐"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <span v-if="row.isRecommend == 1">是</span>
            <span v-if="row.isRecommend == 0">否</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="detailSpu(row)"
                >详情</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="changeSpu(row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="success"
                v-if="row.deleteStatus == 0"
                @click="shelves(row, 1)"
                >上架</el-button
              >

              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="warning"
                @click="shelves(row, 0)"
                v-if="row.deleteStatus == 1"
                >下架</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: auto; marginright: 50px; margintop: 20px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>

    <!-- 详情页面 -->
    <a-drawer
      title="详情"
      :width="1300"
      :visible="detailVisibile"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Detail :Detaildata="detailData" />
    </a-drawer>

    <!-- 修改页面 -->
    <a-drawer
      title="修改"
      :width="1300"
      :visible="changeVisibile"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Change :Changedata="changeData" />
    </a-drawer>
  </div>
</template>
<script>
import Detail from "./detail";
import Change from "./change";
export default {
  components: {
    Detail,
    Change,
  },
  data() {
    return {
      list: [],
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      detailVisibile: false,
      changeVisibile: false,
      detailData: [],
      changeData: [],
      searchData: {
        goodsName: "",
        isRecommend: "",
        customerNumber: "",
      },
      options: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
    };
  },
  methods: {
    addGoods() {
      this.$router.push("/addGoods");
    },
    // 修改spu
    changeSpu(row) {
      this.changeVisibile = true;
      this.changeData = row;
    },
    // 详情
    detailSpu(row) {
      this.detailVisibile = true;
      this.detailData = row;
    },
    getList() {
      this.postAxios("/goods/list/spu", {
        pageEntity: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        goods: {
          goodsName: this.searchData.goodsName,
          isRecommend: this.searchData.isRecommend,
          customerNumber: this.searchData.customerNumber,
        },
      }).then((res) => {
        if (res.success) {
          this.list = res.content;
          this.totalCount = res.totalCount;
        } else {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    clearList() {
      this.searchData = {};
      this.getList();
    },
    onClose() {
      this.detailVisibile = false;
      this.changeVisibile = false;
      this.getList();
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    // 上架下架
    shelves(row, val) {
      this.getAxios("/goods/spu/standAndDown", {
        spuId: row.id,
        state: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less">
.wrapper {
  width: 95%;
  height: auto;
  margin: 20px auto;
}
.done {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-scorll {
  overflow-y: scroll;
  min-height: 600px;
}
</style>